import React, { memo, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import JoinModal from "./Tournament/JoinModal";
import WinningBreakUp from "./Tournament/WinningBreakUp";
import TournamentModal from "./Tournament/TournamentModal";
import TournamentConfirmationModal from "./Tournament/TournamentConfirmationModal";
import RulesModal from "./Tournament/RulesModal";
import { func } from "../../Utilities/logFunc";
import {
  getTournament,
  walletUsageLimit,
  getUserInGameName,
  getAccountProfile,
  getTournamentViaCode,
  getFeaturedTournaments,
} from "../../Utilities/controller";
import { url } from "../../Utilities/url";
import Trophy from "../../assets/images/trophy-svg.svg";
import BasicProfile from "./Tournament/BasicProfile";
import Loader from "../Common/Loader";
import { toast } from "react-toastify";
import ShowFreeContestModal from "../Subscription/ShowFreeContestModal";
import { useProfileDataContext } from "./ProfileContext";
import { useTranslation } from "react-i18next";
import {eventTracking} from "../../firebaseAnalytics"; 
import {events} from "../../Utilities/appEvents"; 

const FeaturedTournament = () => {
  var user_data = JSON.parse(localStorage.getItem("profile"));
  const [tournaments, setTournaments] = useState([]);
  const [showJoinModal, setShowJoinModal] = useState(false);
  const [showWinningModal, setShowWinningModal] = useState(false);
  const [showTournamentModal, setShowTournamentModal] = useState(false);
  const [showTournamentConfirmationModal, setShowTournamentConfirmationModal] =
    useState(false);
  const [isLoading, setLoading] = useState(false);

  const [selectedMatch, setMatch] = useState(null);
  const [selected, setselected] = useState([]);
  const [walletData, setWalletData] = useState([]);
  const [activeTournament, setActiveTournament] = useState(null);
  const [activeCurrencyWallet, setActiveCurrencyWallet] = useState(null);
  const [selectedTournament, setSelectedTournament] = useState(null);
  const [activeInGameName, setActiveInGameName] = useState(null);
  const [inGameNames, setInGameNames] = useState([]);
  const [showPremiumPopupContest, setShowPremiumPopupContest] = useState(false);
  const [showPremiumPopupTournament, setShowPremiumPopupTournament] = useState(false);

  const [showRulesModal, setShowRulesModal] = useState(false);

  const [showBasicProfileModal, setShowBasicProfileModal] = useState(false);
  const [userDataInfo, setUserData] = useState("");
  const [loader, setLoader] = useState(false);
  const { profileData, updateProfileData } = useProfileDataContext()
  const {t} = useTranslation()
  const getTournamentList = async () => {
    setLoader(true);
    try {
      let data = {
        skip: 0,
        limit: 100,
        filter: {
          isFeatured: true,
          user: profileData?.item.user_id,
          tournamentType: "goplay",
        },
      };

      const res = await getFeaturedTournaments();
      if (res?.data) {
        setTournaments(res?.data?.data);
       

        setLoader(false);
      }
      func(res);
    } catch (error) {
      setLoader(false);
      func("avatar 13", error?.response?.data?.errors?.[0]?.msg);
      toast.error(error?.response?.data?.errors?.[0]?.msg)
     
    }
    finally{
      setLoader(false);
    }
  };

  useEffect(() => {
    // getAccountProfileDetails();
    // getUserInGameNameData();
    // console.log("feaured image")
  }, []);


  const getUserInGameNameData = async () => {
    setLoader(true);
    try {
      let data = {
        search: {
          // phone: userDataInfo?.item?.phone,
          // phoneCode: userDataInfo?.item?.phoneCode,
          game: localStorage.getItem("activeGameId"),
          "user": profileData?.item?.user_id,

        },
      };
      func("localStorage.getItem()", localStorage.getItem("activeGameId"))
      const res = await getUserInGameName(data);
      if (res?.data?.data && res?.data?.data?.length > 0) {

        setInGameNames(res?.data?.data)
        let index = res?.data?.data?.findIndex(obj => obj.game === localStorage.getItem("activeGameId"))
        if (index > -1) {
          setActiveInGameName(res?.data?.data[0]?.userINGameName || '')
        }
        setLoader(false);
        return true;
      } else {
        setLoader(false);
        return false;
      }
    } catch (error) {
      setLoader(false);
      setShowJoinModal(false)
      setShowBasicProfileModal(true)
    }
  };

  const handlerJoin = async (data) => {
    getWallet(data);
    setActiveTournament(data);
    setSelectedTournament(data);
    let checkInNameGame = await getUserInGameNameData();
    if (checkInNameGame) {
      setShowTournamentModal(true);
    } else {
      setShowBasicProfileModal(true);
    }
  };

  const getWallet = async (dataItem) => {
    setLoader(true);
    try {
      let data = {
        event: dataItem?._id,
        type: "event",
        currencyCode: dataItem?.currency?.[0]?.inCurrency?._id,
        entryFee: dataItem?.entryFee,
      };

      const res = await walletUsageLimit(data);
      if (res?.data?.item) {
        setActiveCurrencyWallet(res?.data?.item);
        setLoader(false);
      }
    } catch (error) {
      func("getTournament error", error?.response?.data?.errors?.[0]?.msg);
      toast.error(error?.response?.data?.errors?.[0]?.msg)
      setLoading(false);
    }
  };

  useEffect(() => {
    getTournamentList();
  }, []);


  const handlerJoinPopup = async (data) => {
  // func("clikced", data);
  // console.log( data?.gameAry?._id)
  setLoading(true)
    localStorage.setItem("activeGameId", data?.gameAry?._id);
    localStorage.setItem("activeGame", data?.gameAry?.name);
try{

    let payload = {
      code: data.shortCode,
      user: profileData?.item?.user_id

    }
    const res = await getTournamentViaCode(payload);

    if (res?.data?.success == true) {
      console.log("res?.data getTournamentViaCode", res?.data.item)
      eventTracking(events.FEATURE_TOURNAMENTS,{
        GJ_GameName:data?.gameAry?.name, 
        GJ_GameID:data?.gameAry?._id, 
        GJ_TournamentID : res?.data?.item._id, 
        GJ_GameTypename :res?.data?.item?.gameTypeAry?.name,
        GJ_GameTypeID:res?.data?.item?.gameTypeAry?._id,
        
      });
      

      // let index = inGameNames?.findIndex(obj => obj.game == data?.gameAry?.[0]?._id)

      // if (index > -1) {
      //   setActiveInGameName(inGameNames[index].userINGameName || "")
      // }
      // setLoading(false)
      // setShowJoinModal(true);

      // let payloadForGameName = {
      //   search: {
      //     user: profileData?.item?.user_id,
      //     game:data?.gameAry?._id
      //   },
      // };
      // setLoading(true)
      // const resForGameName = await getUserInGameName(payloadForGameName)
      // const game = localStorage.getItem()
      setActiveTournament(res?.data?.item);
      setSelectedTournament(res?.data?.item);
      // if (resForGameName?.data?.success) {
      //   // func(JSON.parse(localStorage.getItem("userInGameNames"))?.data, tournaments?.gameAry?.id)
      //   let gameInName = resForGameName?.data?.data.filter((ele) => ele?.game === res?.data?.item?.gameAry?.[0]?._id)
      //   console.log("ingamename", gameInName)

      //   if (gameInName.length == 0) {
      //     setLoading(false)

      //     setShowBasicProfileModal(true);
      //   }
      //   else {
      //     setActiveInGameName(gameInName[0]?.userINGameName)
          setShowJoinModal(true);
          setLoading(false)
      //   }

      // }

      // // let checkInNameGame = await getUserInGameNameData();

      // // if (activeInGameName) {
      // //   // setShowJVC(false)  
      // //   setShowTournamentModal(true);
      // // }
      // else {
      //   // setShowJVC(false)
      //   setLoading(false)
      //   setShowBasicProfileModal(true);

      // }
    }
  }
    catch(error){
      setLoading(false)
      toast.error(error?.response?.data?.errors?.[0]?.msg)
    }
      // setActiveTournament(res?.data?.itme);
      // setShowJoinModal(true);
    }
  

  const handlerJoinNow = async (tournaments) => {
    getWallet(tournaments);
    setActiveTournament(tournaments);
    setSelectedTournament(tournaments);
    let checkInNameGame = await getUserInGameNameData();
    if(checkInNameGame){
      setShowJoinModal(false);
      setShowTournamentModal(true);
    }
    else {
      setShowJoinModal(false);
      setShowBasicProfileModal(true);
    }
  };

  const handlerWinning = () => {
    func("clicked");
    //selectedTournament
    
    eventTracking(events.Tournamnet_Winners, {
      GJ_GameName: localStorage.getItem("activeGame"),
      GJ_GameID: localStorage.getItem("activeGameId"),
      GJ_ContestID: activeTournament._id,
      GJ_GameTypeID:activeTournament.gameTypeAry._id,
    });
    setShowWinningModal((prev) => true);
  };

  // let colorsOne = ["#FFC609", "#ffb100", "#FFC609"];
  useEffect(() => {
    // Load the GPT library
    const gptScript = document.createElement('script');
    gptScript.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js'; 
    gptScript.async = true;
    document.body.appendChild(gptScript);

    // Initialize the ad slot after the script loads
    // gptScript.onload = () => {
    //   window.googletag = window.googletag || { cmd: [] };
    //   window.googletag.cmd.push(() => {
    //     window.googletag.defineSlot(
    //       '/23081990290,23206251223/goplay.com.Banner0.1732101929', 
    //       [[300,50],[300,100],[320,50],[320,100],[728,90],"fluid"], 
    //       'gpt-passback-goplay.com.Banner0.1732101929'
    //     ).addService(window.googletag.pubads());

    //     window.googletag.enableServices();
    //     window.googletag.display('gpt-passback-goplay.com.Banner0.1732101929');
        
    //     // // Set state to true once the ad is displayed
    //   // setIsAdLoaded(true);
    //   });
    // };

    // Clean up the script tag on component unmount
    return () => {
      document.body.removeChild(gptScript);
    };
  }, []);

  func("location", window.location.pathname.split('/'));
  return  (
    <>
      {/* <div className="col-12 testadds mb-4">
            <div
              id="gpt-passback-goplay.com.Banner0.1732101929"
              style={{
                width: '100%',
                height: "auto",
                bottom: '0',
                zIndex: '9999',
                //  background: "red",
              }}
            >
             The ad slot will be displayed here 
            </div>
        </div> */}
      {tournaments?.length > 0 && (
        <div class="col-12">
          <div class="title mb-3">
            <h2 class="h3 d-flex align-items-center">
              <span class="titleIcon me-3">
                <img src={Trophy} alt="" />
              </span>
              <span>  {t('home.featured_tournament')}  </span>
            </h2>
          </div>

          <Swiper
            className="swiper featuredTournamentSlider commonSlider"
            spaceBetween={20}
            slidesPerView={2}
            // onSlideChange={() => console.log("slide change")}
            // onSwiper={(swiper) => console.log(swiper)}
            navigation
            pagination={{ clickable: true, el: ".swiper-pagination" }}
            modules={[Navigation, Pagination]}
            style={{ cursor: "pointer" }}
            breakpoints={{
              768: {
                slidesPerView: 3,
              },
              1200: {
                slidesPerView: 4,
              },
            }}
          >
            {tournaments.length > 0 &&
              tournaments.map((data, indp) => (

                <SwiperSlide
                  class="swiper-slide"
                  style={{height:'20rem'}}
                  onClick={() => handlerJoinPopup(data)}
                >
                  <div className="d11-featured-bg" style={{
                    backgroundColor:
                      // colorsOne[indp % colorsOne.length], 
                      "var(--accent-color-2)"
                  }}>
                  {/* <div > */}
                    <div class="featuredGameCard card" 
                    style={{ marginTop: '-3rem', borderTopRightRadius: '10px' }}
                    >
                      <div class="card-img" style={{ borderTopRightRadius: '10px' }}>
                        <img
                          class="rounded10"
                          src={url.imageUrl + data?.featuredImage?.default}
                          alt={data?.title}
                        />
                      </div>
                      <div class="card-content">
                        <h2 class="h6">{data?.title}</h2>
                        <hr />
                        <p class="h6 mb-0">{data?.gameAry?.name} - {data?.gameTypeAry?.name}</p>
                      </div>
                    </div>
                    <div class="gameCost">
                      {
                        data?.prizePoolType === 'amount' &&
                        <img
                          src={
                            url.imageUrl +
                            data?.currency?.outCurrency?.img?.default
                          }
                          alt={data?.title}
                        />
                      }
                      <h4 class="m-0 bodyBoldFont">{data?.prizePoolType === 'amount' ? data?.prizePool : data?.rewardDisplayText}</h4>
                    </div>
                  </div>
                </SwiperSlide>

              ))}
            <div class="swiper-pagination"></div>
          </Swiper>
        </div>
      )}
      {/* {console.log(activeTournament,"activeTournament")} */}
      {showJoinModal && (
        <JoinModal
          showJoinModal={showJoinModal}
          setShowJoinModal={setShowJoinModal}
          handlerWinning={handlerWinning}
          handlerJoinNow={handlerJoinNow}
          tournaments={activeTournament}
          setShowRulesModal={setShowRulesModal}
          setSelectedTournament={setSelectedTournament}
        />
      )}
      {showWinningModal && (
        <WinningBreakUp
          showWinningModal={showWinningModal}
          setShowWinningModal={setShowWinningModal}
          selectedTournament={selectedTournament}
        />
      )}
      {showTournamentModal && (
        <TournamentModal
          showTournamentModal={showTournamentModal}
          setShowTournamentModal={setShowTournamentModal}
          setShowTournamentConfirmationModal={
            setShowTournamentConfirmationModal
          }
          setMatch={setMatch}
          tournaments={activeTournament}
        />
      )}

      {showTournamentConfirmationModal && (
        <TournamentConfirmationModal
          showTournamentConfirmationModal={showTournamentConfirmationModal}
          setShowTournamentConfirmationModal={
            setShowTournamentConfirmationModal
          }
          tournaments={selectedTournament}
          walletData={activeCurrencyWallet}
          match={selectedMatch}
            userInGameName={activeInGameName}
            setShowPremiumPopupTournament={setShowPremiumPopupTournament}
        />
      )}

      {showRulesModal && (
        <RulesModal
          showRulesModal={showRulesModal}
          setShowRulesModal={setShowRulesModal}
          selectedTournament={selectedTournament}
        />
      )}

      {showBasicProfileModal && (
        <BasicProfile
          showBasicProfileModal={showBasicProfileModal}
          setShowBasicProfileModal={setShowBasicProfileModal}
          game={localStorage.getItem("activeGameId")}
          setShowTournamentModal={setShowTournamentModal}
        />
      )}
       {
        showPremiumPopupContest  && <ShowFreeContestModal title={"contest"} showPremiumPopupContest ={showPremiumPopupContest} setShowPremiumPopupContest={setShowPremiumPopupContest}  />
      }
       {
        showPremiumPopupTournament  && <ShowFreeContestModal title={"tournament"} showPremiumPopupContest ={showPremiumPopupTournament} setShowPremiumPopupContest={setShowPremiumPopupTournament}  />
      }

    {loader ?  <Loader /> : <></>}
    </>
  );
};

export default memo(FeaturedTournament);
